import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Cache-buster de una sola vez (ver nginx.conf: /assets/i18n/ pasó de
 * `immutable, max-age=1y` a `no-cache, must-revalidate`). Ese cambio de
 * config solo evita que se vuelva a romper — a quien YA tiene el JSON viejo
 * cacheado como immutable, el navegador nunca le manda ni siquiera un GET
 * condicional hasta que expire (hasta 1 año), pase lo que pase en el
 * servidor. La única forma de forzarlo es una URL nueva. Bump manual si
 * hiciera falta forzar otro refetch global; normalmente no hace falta —
 * el fix de nginx ya deja las cargas futuras al día solas.
 */
const CACHE_BUST_2026_08_10 = '2026-08-10';

/**
 * Carga los archivos de traducción por idioma desde /assets/i18n/{lang}.json.
 * Transloco cachea cada idioma tras la primera carga.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string) {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json?v=${CACHE_BUST_2026_08_10}`);
    }
}
